import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useFetchWithToken } from "../FetchWithToken/FetchWithToken";
import { apiUrl } from "../../Constants/Constants";
const TrackOnRouteChange = ({ children }) => {
  const { fetchWithToken } = useFetchWithToken();
  const location = useLocation();

  // useEffect(() => {
  //   let former = new FormData();
  //   former.append("path", location.pathname + location.search);
  //   fetchWithToken(
  //     apiUrl + "stats/track-location-change",
  //     {
  //       method: "POST",
  //     },
  //     former
  //   )
  //     .then((data) => {})
  //     .catch(() => {});
  // }, [location]);

  return <>{children}</>;
};

export default TrackOnRouteChange;
